import axios from 'axios';
import axiosRetry from 'axios-retry';
import qs from 'qs';
import { appConfig } from 'configurations';

const DEFAULT_HEADERS: any = {
    'Content-Type': 'application/json'
};

const FORM_API_HEADERS: any = {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
};

export const accountHttp = axios.create({
    baseURL: appConfig.accountBaseUrl,
    headers: DEFAULT_HEADERS,
    transformRequest: data => JSON.stringify(data)
});

export const hybrisProxyHttp = axios.create({
    baseURL: appConfig.hybrisProxyBaseUrl,
    headers: DEFAULT_HEADERS,
    transformRequest: data => JSON.stringify(data)
});

export const hybrisHttp = axios.create({
    baseURL: appConfig.hybrisBaseUrl,
    headers: DEFAULT_HEADERS,
    transformRequest: data => JSON.stringify(data)
});

export const hybrisFormHttp = axios.create({
    baseURL: appConfig.hybrisBaseUrl,
    headers: DEFAULT_HEADERS
});

export const donationHttp = axios.create({
    baseURL: appConfig.donationBaseUrl,
    headers: DEFAULT_HEADERS,
    transformRequest: data => JSON.stringify(data)
});

export const custexHttp = axios.create({
    baseURL: appConfig.custexBaseUrl,
    headers: DEFAULT_HEADERS,
    transformRequest: data => JSON.stringify(data)
});

const logisticsHttpWithRetryPolicy = axios.create({
    baseURL: appConfig.logisticsUrl,
    headers: DEFAULT_HEADERS,
    transformRequest: data => JSON.stringify(data)
});
axiosRetry(logisticsHttpWithRetryPolicy, { retries: 3 });
export const logisticsHttp = logisticsHttpWithRetryPolicy;

const paymentHttpWithRetryPolicy = axios.create({
    baseURL: appConfig.paymentUrl,
    headers: DEFAULT_HEADERS,
    transformRequest: data => JSON.stringify(data)
});
axiosRetry(paymentHttpWithRetryPolicy, {
    retries: 3,
    retryDelay: retryCount => {
        return retryCount * 1000;
    },
    retryCondition: error => error.isAxiosError || !error.response,
});
export const paymentHttp = paymentHttpWithRetryPolicy;

export const hybrisProxyHttpWithRetryPolicy = axios.create({
    baseURL: appConfig.hybrisProxyBaseUrl,
    headers: DEFAULT_HEADERS,
    transformRequest: data => JSON.stringify(data)
});
axiosRetry(hybrisProxyHttpWithRetryPolicy, { retries: 3 });

export const reservationHttp = axios.create({
    baseURL: appConfig.reservationUrl,
    headers: DEFAULT_HEADERS,
    transformRequest: data => JSON.stringify(data)
});

export const logsHttp = axios.create({
    baseURL: appConfig.logsBaseUrl,
    headers: FORM_API_HEADERS,
    transformRequest: data => qs.stringify(data)
});

export const rabbitHttp = axios.create({
    baseURL: appConfig.rabbitBaseUrl,
    headers: DEFAULT_HEADERS,
    transformRequest: data => JSON.stringify(data)
});

const ifcConfigHttpWithRetryPolicy = axios.create({
    baseURL: appConfig.ifcConfigUrl,
    headers: DEFAULT_HEADERS,
    transformRequest: data => JSON.stringify(data)
});
axiosRetry(ifcConfigHttpWithRetryPolicy, { retries: 3 });
export const ifcConfigHttp = ifcConfigHttpWithRetryPolicy;